import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from './config.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./config.service";
export class FocoService {
    constructor(http, configService) {
        this.http = http;
        this.configService = configService;
        this.jsonContent = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': sessionStorage.getItem('batoken'),
                'User': sessionStorage.getItem('userid')
            })
        };
    }
    list() {
        const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('batoken') });
        return this.http.get(`${this.configService.API_URL}/focos`, { headers }).toPromise();
    }
    create(user) {
        return this.http.post(`${this.configService.API_URL}/focos`, user, Object.assign({}, this.jsonContent, { responseType: 'text' })).toPromise();
    }
    update(user) {
        return this.http.post(`${this.configService.API_URL}/focos/update`, user, Object.assign({}, this.jsonContent, { responseType: 'text' })).toPromise();
    }
    delete(user, focoId) {
        return this.http.post(`${this.configService.API_URL}/focos/delete/${focoId}`, user, Object.assign({}, this.jsonContent, { responseType: 'text' })).toPromise();
    }
    getAllCategorias() {
        const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('batoken') });
        return this.http.get(`${this.configService.API_URL}/focos`, { headers }).toPromise();
    }
    getUltimoId() {
        const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('batoken') });
        return this.http.get(`${this.configService.API_URL}/focos/ultimoId`, { headers }).toPromise();
    }
}
FocoService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FocoService_Factory() { return new FocoService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ConfigService)); }, token: FocoService, providedIn: "root" });
